import { ArrowRight } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { IllustrativeBadge } from "@/components/IllustrativeBadge";
import { LayerLegend } from "@/components/LayerTag";
import { JourneyAnatomy } from "@/components/JourneyAnatomy";

export function JourneyShell({ journey, children }) {
  return (
    <div className="mx-auto max-w-5xl px-5 py-10 sm:px-8" data-testid={`journey-${journey.id}`}>
      <div className="animate-fade-up">
        <div className="mb-3 flex flex-wrap items-center gap-3">
          <IllustrativeBadge />
          <div className="flex items-center gap-2 text-xs font-medium text-mill-muted">
            {journey.chain.map((c, i) => (
              <span key={c} className="flex items-center gap-2">
                <span className="rounded-full bg-mill-alt px-2.5 py-1">{c}</span>
                {i < journey.chain.length - 1 && <ArrowRight className="h-3.5 w-3.5" />}
              </span>
            ))}
          </div>
        </div>
        <h1 className="font-display text-3xl font-bold tracking-tight text-mill-ink sm:text-4xl">{journey.title}</h1>
        <p className="mt-3 max-w-2xl text-base leading-relaxed text-mill-muted">{journey.summary}</p>
      </div>

      <Tabs defaultValue="walkthrough" className="mt-8">
        <TabsList className="bg-mill-alt">
          <TabsTrigger value="walkthrough" data-testid="tab-walkthrough">Walkthrough</TabsTrigger>
          <TabsTrigger value="anatomy" data-testid="tab-anatomy">The six-element anatomy</TabsTrigger>
        </TabsList>

        <TabsContent value="walkthrough" className="mt-6">
          {children}
        </TabsContent>

        <TabsContent value="anatomy" className="mt-6 space-y-6">
          <div className="rounded-2xl border border-stone-200 bg-white p-5">
            <p className="mb-4 text-sm font-semibold text-mill-ink">Every action is labelled by layer:</p>
            <LayerLegend />
          </div>
          <JourneyAnatomy anatomy={journey.anatomy} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
